import ClientUtils from "./../../../utils/ClientUtils";
import { AnimatePresence, HTMLMotionProps, motion } from "framer-motion";
import React from "react";

interface Props extends HTMLMotionProps<"button"> {
  className?: string;
  selected?: boolean;
}

export const ForwardedAppTextButton = React.forwardRef((props, ref) =>
  AppTextButton(props, ref)
);

const AppTextButton: React.FC<Props> = (
  props,
  ref?: React.ForwardedRef<HTMLButtonElement>
) => {
  const { className, children, selected, onClick, ...rest } = props;

  function localOnClick(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    props.onClick && props.onClick(e);
  }

  return (
    <AnimatePresence initial={false}>
      <motion.button
        {...rest}
        ref={ref}
        className={ClientUtils.twClassNames(
          "font-semibold hover:underline disabled:pointer-events-none disabled:opacity-50",
          className
        )}
        onClick={localOnClick}
      >
        {props.children}
      </motion.button>
    </AnimatePresence>
  );
};

export default AppTextButton;
